export default "__VITE_ASSET__DcpQHJod__"